export default "__VITE_ASSET__c591c6a2__"